import { Component } from "@angular/core";
import { NotificationStateService } from "../services/notification.service";
import { INotificationData } from "../model/ddb.model";
import { IQueryFilter } from "../model/query.filter.class";
import { Router } from "@angular/router";
import { SessionApi } from "../api/session.api";
import { IAuthDataResponse } from "../model/session.model";
import { AppHeaderComponent } from "../template/app-header/app-header.component";
import { SecurityService } from "../services/security.service";

@Component({
  selector: "app-manage-notification",
  templateUrl: "./manage-notification.component.html",
  styleUrls: ["./manage-notification.component.sass"],
})
export class ManageNotificationComponent {
  notificationsList: INotificationData[] = [];
  user: IAuthDataResponse | null;
  showBalance: boolean = false;

  constructor(
    private notificationState: NotificationStateService,
    private router: Router,
    private session: SessionApi,
    private appHeaderComponent: AppHeaderComponent,
    private security: SecurityService
  ) {
    this.user = this.session.$userData.value;
    this.listNotification();
    this.notificationState.hasNewNotification$.subscribe((value) => {
      if (value) {
        this.listNotification();
      }
    });

    security.showOwnBalance().subscribe((show) => {
      this.showBalance = show;
    });
  }

  listNotification() {
    this.notificationState
      .loadNotifications(
        new IQueryFilter({ filter: { userId: this.user?.id, isRead: false } }),
      )
      .subscribe((data) => {
        this.notificationsList = data.rows;
        const hasUnread = data.rows.some((n) => n.isRead === false);

        if (hasUnread) {
          this.appHeaderComponent.hasNewNotification = true;
        }
      });
  }

  markRead() {
    this.notificationState
      .update({ isRead: true, markAll: true })
      .subscribe(() => {
        this.appHeaderComponent.hasNewNotification = false;
        this.listNotification();
      });
  }

  remove(id: string) {
    this.notificationState.delete(id).subscribe(() => {
      this.listNotification();
    });
  }

  getTypeMessage(data: INotificationData) {
    switch (data.type) {
      case "Order Dispatch":
        return "New Order Notification!";
      case "Order Approval":
        return "New Order Notification!";
      case "Allocation":
        return "Allocation Update Notification!";
      case "Store Order":
        return "New Store Order Notification!";
      default:
        return "New SUMS Notification!";
    }
  }

  goToLink(data: INotificationData) {
    if (data.id) {
      this.notificationState
        .update({ isRead: true, markAll: false, id: data.id })
        .subscribe((res) => {
          switch (data.type) {
            case "Order Dispatch": {
              return this.router.navigate([
                this.user?.isAdmin ? "/manage/orders/" : "/account/orders/",
                data.externalId,
              ]);
            }
            case "Order Approval": {
              return this.router.navigate([
                this.user?.isAdmin ? "/manage/orders/" : "/account/orders/",
                data.externalId,
              ]);
            }
            case "Allocation": {
              return this.showBalance ? this.router.navigate(["/account/balance"]) : null;
            }
            case "Store Order": {
              return this.router.navigate([
                "/account/store/employee-orders",
                data.externalId,
              ]);
            }
          }
        });
    }
  }

  linkMessage(data: INotificationData) {
    switch (data.type) {
      case "Order Dispatch":
        return "Go to Order!";
      case "Order Approval":
        return "Go to Order!";
      case "Allocation":
        return this.showBalance ? "Go to Balance" : '';
      case "Store Order":
        return "New Store Order Notification!";
      default:
        return "New SUMS Notification!";
    }
  }
}
